import React, { Component } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import NavigationArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import NavigationMenu from 'material-ui/svg-icons/navigation/menu';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { DefaultButton } from '../../components/Buttons';
import { login } from '../../settings/settings';
import { BREAK_POINT_LARGE } from './../../data/constants/index.js';
import LogoHome from '../../components/LogoHome';
import DrawerProfile from '../../components/DrawerProfile';
import DrawerMenu from '../../components/DrawerMenu';
import { getShortDateTimeStr, fetchVersionAsync } from './../../utilities/helpers';
import AlertDialog from '../AlertDialog';
import appHistory from '../../appHistory';
import oidcAuthConfig from '../../oidcAuthConfig';
import './styles.scss';

// Remove static label loading. Labels will be injected via props from wrapper.

const ToggleLogoutBtn = withStyles({
  root: {
    borderRadius: '100%',
    border: 'none'
  },
})(DefaultButton);

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {

      openDrawer: false,
      open: false,
      dockedMenu: true,
      below: false,
      above: false,
      version: ''
    };
    this.handleLeftTap = this.handleLeftTap.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }
  componentDidMount = () => {
    this.mounted = true;
    this.evaluateResolution();
    window.addEventListener('resize', this.evaluateResolution);
    this.unlisten = appHistory.listen((location, action) => {
      console.log(`evaluateResolution() - The current URL is ${location.pathname}${location.search}${location.hash}`);
      console.log(`evaluateResolution() - The last navigation action was ${action}`);
      this.evaluateResolution();
    });

    // Fetch version using centralized helper with mounted check
    fetchVersionAsync()
      .then((version) => {
        if (this.mounted) {
          this.setState({ version });
        }
      })
      .catch(() => {
        if (this.mounted) {
          this.setState({ version: '' });
        }
      });
  };
  componentWillUnmount = () => {
    this.mounted = false;
    window.removeEventListener('resize', this.evaluateResolution);
    this.unlisten();
  };
  evaluateResolution = () => {
    if (window.matchMedia(`(max-width: ${BREAK_POINT_LARGE})`).matches) {
      if (!this.state.below) {
        this.setState(state => ({
          ...state,
          openDrawer: false,
          dockedMenu: false,
          below: true,
          above: false
        }));
      }
    } else if (!this.state.above) {
      this.setState(
        state => ({
          ...state,
          openDrawer: true,
          dockedMenu: true,
          above: true,
          below: false
        }),
        () => {
          const container = document.querySelector('.card-container');
          if (this.state.openDrawer && container) {
            container.style.paddingLeft = '320px';
          }
        }
      );
    }
  };
  handleLeftTap() {
    this.setState({ openDrawer: !this.state.openDrawer }, () => {
      const container = document.querySelector('.card-container');
      if (container) {
        container.style.paddingLeft = this.state.openDrawer ? '320px' : '15px';
      }
    });
  }
  handleOpen() {
    this.setState({ open: true });
  }
  handleClose() {
    this.setState({ open: false });
  }
  handleLogout() {
    if (login.authType === 'OIDC') {
      // Preserve language preference across logout
      const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
      const logoutUrl = oidcAuthConfig.logoutUrl;
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = logoutUrl;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'original_url';
      input.value = logoutUrl;
      form.appendChild(input);

      document.body.appendChild(form);
      form.submit();
      sessionStorage.clear();
      // Restore language preference after clearing session
      if (tempLng) {
        localStorage.setItem('lng', tempLng);
        sessionStorage.setItem('lng', tempLng);
      }
      return;
    }
    const logoutPath = '/login';
    this.setState({ open: false }, this.props.logout(logoutPath));
    if (login.authType !== 'MSAL') {
      // Preserve language preference
      const tempLng = localStorage.getItem('lng') || sessionStorage.getItem('lng');
      sessionStorage.clear();
      localStorage.clear();
      // Restore language preference
      if (tempLng) {
        localStorage.setItem('lng', tempLng);
        sessionStorage.setItem('lng', tempLng);
      }
    }
    window.location.href = logoutPath;
    window.location.reload();
  }
  handleMenuChange = () => {
    if (!this.state.dockedMenu) {
      this.setState({ openDrawer: false });
    }
  };
  render() {
    const appBarStyles = {
      background: '#4A4A4A',
      height: '70px',
      position: 'fixed'
    };
    const isHeaderLayout = this.props.isHeaderLayout;
    const extraClass = isHeaderLayout ? 'hidden' : '';

    return (
      <div className='navigation'>
        <AppBar
          style={appBarStyles}
          id='top-nav-bar'
          title={<LogoHome />}
          className={extraClass}
          onRightIconButtonTouchTap={this.handleOpen}
          iconElementRight={<ToggleLogoutBtn><ExitToAppIcon style={{color: "white"}}/></ToggleLogoutBtn>}
          iconElementLeft={
            this.state.openDrawer === true ? (
              <Button onClick={this.handleLeftTap}>
                <NavigationArrowBack style={{color: 'white'}}/>
              </Button>
            ) : (
              <Button onClick={this.handleLeftTap}>
                <NavigationMenu />
              </Button>
            )
          }
        ></AppBar>
        {!isHeaderLayout && (
          <div>
            <Drawer
              open={this.state.openDrawer}
              className={`Drawer ${!this.state.dockedMenu ? 'docked' : ''} ${
                this.state.openDrawer ? 'shown' : 'hidden'
              }`}
              width={300}
              docked={this.state.dockedMenu}
              onRequestChange={this.handleMenuChange}
              overlayClassName={'menu-overlay'}
            >
              <DrawerProfile user={this.props.staff} />
              <DrawerMenu
                handleOpen={this.handleOpen}
                handleMenuChange={this.handleMenuChange}
                user={this.props.staff}
                staff={this.props.staff}
              />
              <div className='drawer-footer'>
                <span>
                  {this.props.labels.commonLabels?.ADOPT_C}
                  <br />
                  {`${this.props.labels.commonLabels?.LAST_LOGIN}
                 ${getShortDateTimeStr(this.props.staff.crewInterfaceLastUse)}`}
                     <br />
                     {`${this.props.labels.commonLabels?.VERSION_PREFIX} ${this.state.version}`}
                </span>
              </div>
            </Drawer>
            <AlertDialog
              alertDialogTitle={`${this.props.labels.commonLabels?.LOG_CONFIRM_MESSAGE}`}
              openAlertDialog={this.state.open}
              handleOk={this.handleLogout}
              handleCancel={this.handleClose}
              okButtonLabel={`${this.props.labels.logout?.OK_BUTTON}`}
              cancelButtonLabel={`${this.props.labels.logout?.CANCEL_BUTTON}`}
            />
          </div>
        )}
      </div>
    );
  }
}

Navigation.defaultProps = {
  user: {},
  isHeaderLayout: false,
  logout: () => {},
  staff: {}
};

Navigation.propTypes = {
  logout: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isHeaderLayout: PropTypes.bool.isRequired,
  staff: PropTypes.object.isRequired,
  labels: PropTypes.object
};

// Wrapper component to inject language context
function NavigationWrapper(props) {
  const { labels } = useLanguage();
  return <Navigation {...props} labels={labels} />;
}

export default NavigationWrapper;
